module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ge-Ha-Id-Ja.67c0946a.png";